export enum EventCurrency {
    PLN = 0,
    EUR = 1,
    CZK = 2,
}